import React, {useEffect, useState} from 'react';
import { Button, Row, Col, Form, Modal } from 'react-bootstrap';
// For Translate
import './../../../translations/i18n';
import { useTranslation } from 'react-i18next';
//For Form Validation
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
//For Sweet alert 
import Swal from 'sweetalert2'
//Service load
import { sentContact, getAllService } from './../../../services/public.service';
import { useSelector } from 'react-redux';
const RequestServiceModal = (props) => {
    const { t } = useTranslation();
    const language = useSelector((state) => state.user.language);
    const {show, onClose, serviceType, recaptchValidate} = props; 
    const [isButtonLoading, setIsButtonLoading] = useState();
    const [services, setServices] = useState([]);
    //form validation scheme
	const contactFormSchema = Yup.object().shape({
		name: Yup.string().required(t('Name is required')),
        email: Yup.string().email(t('Email is invalid')).required(t('Email is required')),
        phone: Yup.string().required(t('Phone is required')).matches(/^([0-9]*)$/, t('Phone number is not valid')),
        service: Yup.string().required(t('Service is required')),
        message: Yup.string().required(t('Message is required'))
	});
    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(contactFormSchema),
    });
    useEffect(()=>{
        getServices();
        setValue("service", serviceType);
    }, []); // run this use effect when component is rendar
    useEffect(()=>{
        setValue("service", serviceType);
    }, [services]); // run this use effect when component is rendar
    /**Get All Service */
    const getServices = async() =>{
        try{
            const service_result = await getAllService();
            if(service_result){
                setServices(service_result);
            }
        }catch(err){
            console.error(`get service error ${err}`);
            Swal.fire({
                position:'top',
                html:`<div class="d-flex jSaC"><div class="icn"><i class="fa-solid fa-circle-exclamation"></i></div><section class="txt pr-3">${t('Unable to get service.')}</section></div>`,
                showConfirmButton:false,
                customClass:{popup:'cstm alrt-error',},
                timer:2500
            });
        }
    }
    /**Form submit Function */
    const onSubmit = async(formData)=>{
        try{
            setIsButtonLoading(true);
            let payload = formData;
            payload.language = language;
            let result = await sentContact(payload);
            if (result) {
                setIsButtonLoading(false);
                reset();
                onClose();  // props function close
                Swal.fire({
                    position:'top',
                    html:`<div class="d-flex jSaC"><div class="icn"><i class="fa-solid fa-circle-check"></i></div><section class="txt pr-3">${t('Your request has been sent successfully.')}</section></div>`,
                    showConfirmButton:false,
                    customClass:{popup:'cstm alrt-success',},
                    timer:2500
                });
            }
        }catch(err){
            setIsButtonLoading(false);
            Swal.fire({
                position:'top',
                html:`<div class="d-flex jSaC"><div class="icn"><i class="fa-solid fa-circle-exclamation"></i></div><section class="txt pr-3">${t('Unable to send mail.')}</section></div>`,
                showConfirmButton:false,
                customClass:{popup:'cstm alrt-error',},
                timer:2500
            });
        }
    }
    const onCloseHandle = ()=>{
        reset(); // form reset
        onClose();  // props function close
    }
    return (
        <>
            <Modal show={show} onHide={onClose} size="lg">
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t('Request service')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row xs={1} md={2}>
                            <Col className="mb-3">
                                <Form.Label>{t('Name')}<i>*</i></Form.Label>
                                <Form.Control 
                                    type="text"
                                    name="name"
                                    className={errors?.name ? 'is-invalid' : ''}
                                    {...register("name")}
                                />
                                <div className="invalid-feedback">{errors?.name?.message}</div>
                            </Col>
                            <Col className="mb-3">
                                <Form.Label>{t('Email')}<i>*</i></Form.Label>
                                <Form.Control  
                                    type="email"
                                    name="email"
                                    className={errors?.email ? 'is-invalid' : ''}
                                    {...register("email")}
                                />
                                <div className="invalid-feedback">{errors?.email?.message}</div>
                            </Col>
                        </Row>
                        <Row xs={1} md={2}>
                            <Col className="mb-3">
                                <Form.Label>{t('Phone')}<i>*</i></Form.Label>
                                <Form.Control 
                                    type="text"
                                    name="phone"
                                    className={errors?.phone ? 'is-invalid' : ''}
                                    {...register("phone")}
                                />
                                <div className="invalid-feedback">{errors?.phone?.message}</div>
                            </Col>
                            <Col className="mb-3">
                                <Form.Label>{t('Service')}<i>*</i></Form.Label>
                                {/* <Form.Select 
                                    name="service" 
                                    {...register("service")} 
                                    className={errors?.service ? 'is-invalid' : ''} 
                                >
                                    <option value="">{t('Select')}</option>
                                    <option value="audit">Audit Service</option>
                                    <option value="zakat">Zakat and Tax Service</option>
                                    <option value="bookkeeping">Bookkeeping</option>
                                </Form.Select> */}
                                <Form.Select 
                                    name="service" 
                                    {...register("service")} 
                                    className={errors?.service ? 'is-invalid' : ''} 
                                >
                                    <option value="">{t('Select')}</option>
                                    {services?.length > 0 && services?.map((ser)=>(
                                        <option value={ser?.title?.[language]} key={ser?._id}>{t(`${ser?.title?.[language]}`)}</option>
                                    ))}                                    
                                </Form.Select>
                                <div className="invalid-feedback">{errors?.service?.message}</div>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="mb-3">
                                <Form.Label>{t('Message')}<i>*</i></Form.Label>
                                <Form.Control 
                                    as="textarea" 
                                    rows={4} 
                                    name="message"
                                    {...register("message", {required : true})}
                                    className={errors?.message ? 'is-invalid' : ''}
                                />
                                <div className="invalid-feedback">{errors?.message?.message}</div>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer className="pt-0">
                         {/* {!recaptchValidate && <div className="invalid-feedback" style={{textAlign:"end"}}>{t('Recaptch validation failed*')} </div>} */}
                        <Button variant="outline-thm2 nofcs" onClick={onCloseHandle} aria-label="Close">{t('Close')}</Button>
                        <Button 
                            variant="thm1 nofcs" 
                            type="submit" aria-label="Submit"
                            // disabled={isButtonLoading || !recaptchValidate}
                            disabled={isButtonLoading }
                            className={isButtonLoading && `loading`}
                        >{t('Submit')}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
}

export default RequestServiceModal;